import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/lib/api';

/** One client for the app. Query keys always start with the org id; see docs/data-layer.md. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Never retry an auth or validation failure; retry network and 5xx twice.
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});
